import $ from 'jquery'
import { registerComponent } from '../app'
import { USER_SCROLL, WINDOW_RESIZE } from '../events'
import Scroll from '../services/Scroll'
import Browser from '../services/Browser'

const AnimateEntry = (scope, el) => {
	const props = {
		activeClass: 'active',
		threshold: el.getAttribute('data-threshold') || 0.9
	}

	const state = {
		position: 0
	}

	scope.on(USER_SCROLL, () => {
		checkPosition()
	})

	scope.on(WINDOW_RESIZE, () => {
		setTimeout(() => setPosition(), 500)
	})

	function setPosition() {
		state.position = $(el).offset().top
	}

	function checkPosition() {
		if (Scroll.position() + Browser.height() * props.threshold > state.position) {
			el.classList.add(props.activeClass)
		} else {
			el.classList.remove(props.activeClass)
		}
	}

	setPosition()

	scope.start(() => checkPosition())
	setTimeout(() => checkPosition(), 500)
}

registerComponent('animate-entry', AnimateEntry)
